import { ColumnListProps } from './types'

export const ColumnList = ({ columns, data, showColumns = false }: ColumnListProps) => {
    const useFlex = columns.some(col => col.flex !== undefined);
    const gridTemplateColumns = !useFlex ? columns.map(col => col.maxWidth || '1fr').join(' ') : undefined;

    return (
        <div className="rounded-lg bg-base-background ">
            {showColumns && (
                <div
                    className={`${useFlex ? 'flex' : 'grid'} border-b border-base-sidebarBorder bg-base-sidebarBorder/10`}
                    style={useFlex ? undefined : { gridTemplateColumns }}
                >
                    {columns.map((column, colIndex) => {
                        const flexStyle = column.flex !== undefined ? { flex: column.flex } : undefined;
                        const maxWidthStyle = column.maxWidth ? { maxWidth: column.maxWidth } : undefined;
                        const style = useFlex ? { ...flexStyle, ...maxWidthStyle } : maxWidthStyle;

                        return (
                            <div
                                key={`header-${column.accessor}`}
                                className="px-6 py-4 text-sm text-base-mutedForeground text-left"
                                style={style}
                            >
                                {column.header}
                            </div>
                        );
                    })}
                </div>
            )}
            {data.map((row, rowIndex) => (
                <div
                    key={row.id || rowIndex}
                    className={`${useFlex ? 'flex' : 'grid'} overflow-visible ${rowIndex !== data.length - 1 ? 'border-b border-base-sidebarBorder' : ''}`}
                    style={useFlex ? undefined : { gridTemplateColumns }}
                >
                    {columns.map((column) => {
                        const value = row[column.accessor];
                        const content = column.render ? column.render(value, row) : value;
                        const isStringContent = typeof content === 'string' || typeof content === 'number';

                        const flexStyle = column.flex !== undefined ? { flex: column.flex } : undefined;
                        const maxWidthStyle = column.maxWidth ? { maxWidth: column.maxWidth } : undefined;
                        const style = useFlex ? { ...flexStyle, ...maxWidthStyle } : maxWidthStyle;

                        return (
                            <div
                                key={`${row.id || rowIndex}-${column.accessor}`}
                                className={`px-6 py-4 text-sm text-base-foreground text-left ${isStringContent ? 'truncate' : ''} ${column.render ? 'overflow-visible relative' : ''}`}
                                title={isStringContent ? String(content) : undefined}
                                style={style}
                            >
                                {content}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

